module.exports = __webpack_public_path__ + "media/flags/np-ace19899.svg";